import SelectAbstract from 'components/SelectAbstract';
import PropTypes from 'prop-types';

import Input from "components/Input";

import { ReactComponent as ArrowIcon } from 'icons/components/arrowSelect.svg';

import './index.less';
import './themes/default.less';

export default class SelectComplite extends SelectAbstract {

    constructor(props) {
        super(props);

        const defaultItem = props.items.find(item => item.id === props.value);

        this.state = {
            value: defaultItem ? defaultItem.name : "",
            selected: defaultItem ? [defaultItem.id] : [],
        };
    }

    static propTypes = {
        ...SelectAbstract.propTypes,
        showLeftIcon: PropTypes.bool,
        leftIcon: PropTypes.element,
        label: PropTypes.string,
        helpText: PropTypes.string,
        required: PropTypes.bool,
        onChangeInput: PropTypes.func,
        placeHolder: PropTypes.string,
        type: PropTypes.oneOf(['primary', 'secondary']),
    };
    static defaultProps = {
        ...SelectAbstract.defaultProps,
        showLeftIcon: false,
        leftIcon: null,
        label: "",
        helpText: "",
        required: false,
        onChangeInput: null,
        placeHolder: "",
        type: "primary",
    };

    getRightIcon(opened) {
        const openState = opened ? "rotate180" : "";

        return <ArrowIcon className={`arrowIcon transit025 ${openState}`} />;
    }

    getMainStyle() {
        return `select flex flex1`;
    }

    getPopupItemStyle({ id }) {
        const cl = this.state.selected?.includes(id) ? " select" : "";
        return "popupItem hand" + cl;
    }

    onChangeInput(value, show = true) {
        if (show)
            this.setOpenedState(true);

        const selected = this.props.items.reduce((acc, it) => {
            if (value && it.name && it.name.toLowerCase() === value.toLowerCase())
                acc.push(it.id);
            return acc;
        }, []);

        if (this.props.onChangeInput?.apply)
            this.props.onChangeInput(selected[0], value);

        this.setState({ value, selected });

    }

    onEnter() {
        this.setOpenedState(false);
    }

    getCurrentIndex(arrow) {
        const { value } = this.state;
        const { items } = this.props;
        const index = items.findIndex(it => it.name === value);
        if (arrow === "down")
            return index === items.length - 1 ? 0 : index + 1;

        return index < 1 ? items.length - 1 : index - 1;
    }

    onArrowDown() {
        const { items } = this.props;
        const currentName = items[this.getCurrentIndex("down")].name;
        this.onChangeInput(currentName, false);
    }

    onArrowUp() {
        const { items } = this.props;
        const currentName = items[this.getCurrentIndex("up")].name;
        this.onChangeInput(currentName, false);
    }

    onEscape() {
        this.setOpenedState(false);
    }

    onBlur() {
        this.blurTimeout = setTimeout(() => {
            this.setOpenedState(false);
        }, 150);
    }

    selectItem(index, { name }) {
        clearTimeout(this.blurTimeout);
        this.setOpenedState(false);
        this.onChangeInput(name, false);
    }

    renderSelector(items, opened, index) {
        const { selected, value } = this.state;
        const { placeHolder } = this.props;

        const rightIcon = this.getRightIcon(opened);

        return (<div
            ref={el => this.selector = el}
            className="selectComplite flex flex1 gap8 centerV"
        >
            <Input
                itemStyle="flex1"
                value={value}
                placeHolder={placeHolder}
                onClick={this.toggleOpenedState.bind(this)}
                onChange={this.onChangeInput.bind(this)}
                mainStyle={(!value || selected?.length > 0) ? "" : "error"}
                onEnter={this.onEnter.bind(this)}
                onArrowDown={this.onArrowDown.bind(this)}
                onArrowUp={this.onArrowUp.bind(this)}
                onEscape={this.onEscape.bind(this)}
                onBlur={this.onBlur.bind(this)}
            />
            {!!rightIcon && rightIcon}
        </div>);
    }
}
